export const RoutePostMerchflows_merchflowId_StoresValidate =
  "/merchflows/:merchflowId/stores/validate";

export interface PayloadPostMerchflows_merchflowId_StoresValidate {
  store_codes: string[];
}

export interface ResponsePostMerchflows_merchflowId_StoresValidate {
  valid_stores: string[];
  invalid_stores: string[];
}
